export default "__VITE_PUBLIC_ASSET__f7582065__"